// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Programs from './pages/Programs';
import Students from './pages/Students';
import Reports from './pages/Reports';
import FAQ from './pages/FAQ';
import Login from './pages/Login';
import { DataProvider, useDataContext } from './contexts/DataContext';

function AppShell() {
  const { user, authLoading } = useDataContext();

  if (authLoading) return <div className="p-8">Loading...</div>;

  return (
    <Router>
      {user ? (
        <>
          <Navbar />
          <div className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/students" element={<Students />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/faq" element={<FAQ />} />
            </Routes>
          </div>
        </>
      ) : (
        <Login />
      )}
    </Router>
  );
}

export default function App() {
  return (
    <DataProvider>
      <AppShell />
    </DataProvider>
  );
}
